export const CODE_IN_CORSO_DI_DEFINIZIONE = '997';
export const LABEL_IN_CORSO_DI_DEFINIZIONE = 'In corso di definizione';
